import React, { useEffect, useState, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { GetDeliveryWithPid } from './../../../services/get-delivery'
import ProgressCircle from '../../../components/ProgressCircle'
import { changeDeliveryStatus, updateComment } from '../../../services/update-delivery'
import cancelDelivery from '../../../services/cancel-delivery'
import verifyDelivery from '../../../services/verify-delivery'
import firebaseGetImageUrl from '../../../helpers/firebaseGetImageUrl'
export default function DeliveryScreen() {
  const { order_number } = useParams();
  const [loading, setLoading] = useState(false);
  const [delivery, setDelivery] = useState(null);
  const [comment, setComment] = useState("");
  const [state, setState] = useState("needs-pickup"); // 'needs-pickup', 'in-delivery', 'delivered'
  const [changingState, setChangingState] = useState(false);
  const commentRef = useRef();
  const [_photos, setPhotos] = useState([]);

  async function ChangeState(stateName) {
    if (changingState)
      return;
    setChangingState(true);
    const result = await changeDeliveryStatus(stateName, delivery.order_id);
    if (result) {
      setState(stateName);
    }
    setChangingState(false);
  }

  async function GetFullDeliveryInfo() {
    if (loading) return;
    setLoading(true)
    const delivery = await GetDeliveryWithPid(order_number)
    setDelivery(delivery || null)
    setComment(delivery.comment)
    setState(delivery.state)
    setLoading(false)

    // load images
    const output = [];
    const photos = delivery.prod.photos;
    for (let i = 0; i < photos.length; i++) {
      const photo = photos[i];
      const url = await firebaseGetImageUrl(photo);
      output.push(url);
    }
    setPhotos(output);
  }

  async function SaveComment() {
    if (loading) return;
    setLoading(true)
    await updateComment(commentRef.current.value, delivery.order_id)
    setLoading(false)
    GetFullDeliveryInfo()
  }

  async function _CancelAndDelete() {
    if (loading) return;
    setLoading(true);
    try {
      const data = await cancelDelivery("delete", delivery.order_id);
      setLoading(false);
      if (data.result && data.message) {
        console.info(data);
        window.open("/deliveries", "_self");
      } else {
        console.error(data);
      }
    } catch (err) {
      console.log(err)
      setLoading(false);
    }
  }

  async function _VerifyDelivery() {
    if (loading) return;
    setLoading(true);
    const data = await verifyDelivery(delivery.order_id);
    setLoading(false);
    if (data.result && data.message) {
      window.open("/deliveries", "_self");
    } else {
      console.error(data);
    }
  }

  async function _CancelAndPutBack() {
    if (loading) return;
    setLoading(true);
    try {
      const data = await cancelDelivery("put-back", delivery.order_id);
      setLoading(false);
      if (data.result && data.message) {
        console.info(data);
        window.open("/deliveries", "_self");
      } else {
        console.error(data);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  }

  function StateButton({ stateName, title, state }) {
    return (<button
      style={{ position: 'relative' }}
      onClick={() => {
        ChangeState(stateName)
      }}
      className={'btn m-1 ' + (state === stateName ? 'btn-success' : 'btn-dark')}>
      {changingState && <div style={{ position: 'absolute', top: 4, left: 4 }}>
        <ProgressCircle color={'#fff'} size={'24px'} />
      </div>}
      {title}
    </button>);
  }

  useEffect(() => {
    GetFullDeliveryInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <div style={{ width: 'max-content', margin: 'auto', marginTop: '42vh' }}>
      <ProgressCircle />
    </div>;
  }

  return (
    <div className="container-sm p-2">
      <div style={{ maxWidth: 600, margin: 'auto' }}>
        {/* Context */}
        {delivery &&
          <div className={"card p-3 shadow"}>
            <h1># {delivery.order_number && delivery.order_number}</h1>
            <h2>{delivery.prod.category && delivery.prod.category}</h2>
            <h3>{delivery.prod.subCategory && delivery.prod.subCategory}</h3>
            <h4>{delivery.prod.brand && delivery.prod.brand}</h4>
            <div className={"card p-2 mt-2"}>
              <h4>გამყიდველი</h4>
              <a href={`/p/${delivery.seller.uid}`} >სახელი: {delivery.seller.firstName && delivery.seller.firstName}</a>
              <p>ნომერი: {delivery.seller.mobileNumber && delivery.seller.mobileNumber}</p>
              <p>მისამართი: {delivery.seller.address && delivery.seller.address}</p>
              <a className={"btn btn-primary"} href={`tel: ${delivery.seller.mobileNumber && delivery.seller.mobileNumber}`}>
                დარეკვა: {delivery.seller.mobileNumber && delivery.seller.mobileNumber}
              </a>
            </div>
            <div className={"card p-2 mt-2"}>
              <h4>მყიდველი</h4>
              <a href={`/p/${delivery.buyer.uid}`} >სახელი: {delivery.buyer.firstName && delivery.buyer.firstName}</a>
              <p>ნომერი: {delivery.buyer.mobileNumber && delivery.buyer.mobileNumber}</p>
              <p>მისამართი: {delivery.buyer.address && delivery.buyer.address}</p>
              <a className={"btn btn-primary"} href={`tel: ${delivery.buyer.mobileNumber && delivery.buyer.mobileNumber}`}>
                დარეკვა: {delivery.buyer.mobileNumber && delivery.buyer.mobileNumber}
              </a>
            </div>
            <div className={"card p-2 mt-2"}>
              <p>მიტანის პროცესი</p>

              <StateButton state={state} title={'ასაღებია'} stateName={"needs-pickup"} />
              <StateButton state={state} title={'გზაშია'} stateName={"in-delivery"} />
              <StateButton state={state} title={'ჩაბარებულია'} stateName={"delivered"} />

            </div>
            <div className={"card p-2 mt-3"}>
              <div className="form-group">
                <small style={{ opacity: 0.4, fontSize: 12 }}>კომენტარი არ აისახება მყიდველის ან გამყიდველის აპლიკაციაში. ესაა უბრალოდ რომ დამატებითი ინფორმაცია იყოს სადმე შენახული. მაგალითად დავურეკეთ კლიენტს და გვთხოვა რომ სხვა მისამართზე მიგვეტანა ან სხვა დროს</small>
                <textarea ref={commentRef}
                  value={comment}
                  onChange={(e) => { setComment(e.value) }}
                  placeholder={"კომენტარები..."}
                  style={{ minHeight: 100 }}
                  className={"form-control rounded-2"}></textarea>
                <button onClick={SaveComment} className={"btn btn-primary mt-2"}>შენახვა</button>
              </div>
            </div>

            <div className={"card p-2 mt-3"}>

              <button onClick={_VerifyDelivery} className={"btn m-2 btn-success"}>
                წარმატებით დასრულება
              </button>
              <small className={'alert alert-success'} style={{ marginLeft: 10, marginRight: 10 }}>
                ფულის გადარიცხვა გამყიდველის ანგარიშზე
              </small>

              <button onClick={_CancelAndPutBack} className={"btn m-2 btn-danger"}>
                გაუქმება (პროდუქტის უკან დაბრუნებით)
              </button>
              <small className={'alert alert-danger'} style={{ marginLeft: 10, marginRight: 10 }}>
                გაყიდვა გაუქმდება და პროდუქტი დაბრუნდება უკან აპლიკაციაში
              </small>

              <button onClick={_CancelAndDelete} className={"btn m-2 btn-danger"}>
                გაუქმება (პროდუქტის წაშლით)
              </button>
              <small className={'alert alert-danger'} style={{ marginLeft: 10, marginRight: 10 }}>
                გაყიდვა გაუქმდება და პროდუქტი წაიშლება
              </small>
            </div>

            <div>
              {_photos.map((photo, index) => {
                return (<img key={index} onClick={() => { window.open(photo, '_blank'); }}
                  style={{ width: '100%' }} alt={""} src={photo} />);
              })}
            </div>

          </div>}
      </div>
    </div>
  )
}
